import axios from 'axios';
import SortService from '@/services/sort.service'

export default {
    namespaced: true,
    state: {
        loadingRecords: false,
        currentPage: 1,
        records: []
    },
    mutations: {
        SET_CURRENT_PAGE(state, page_number) {
            state.currentPage = page_number;
        },
        SET_LOADING_RECORDS(state, loading) {
            state.loadingRecords = loading;
        },
        SET_RECORDS(state, records) {
            state.records = SortService.formatCreatedAtInObject(records);
        },
        SOCKET_RECORD_ADD(state, record) {
            record.createdAt = SortService.formatDate(record.createdAt);
            state.records.push(record);
        },
        REALTIME_RECORD_ADD_TAB(state, record) {
            record.createdAt = SortService.formatDate(record.createdAt);
            state.records.unshift(record);
        },
    },
    getters: {
        records: (state) => state.records,
        currentPage: (state) => state.currentPage
    },
    actions: {
        loadRecords({ commit }) {
            commit("SET_LOADING_RECORDS", true);

            axios.get(`records/all`)
                .then(res => {
                    commit("SET_RECORDS", res.data.records);
                    commit("SET_LOADING_RECORDS", false);
                }).catch(e => {
                    console.log(e);
                    commit("SET_LOADING_RECORDS", false);
                })
        },
        loadRecordsByLeadId({ commit }, lead_id) {
            commit("SET_LOADING_RECORDS", true);

            axios.get('records/lead/' + lead_id)
                .then(res => {
                    commit("SET_RECORDS", res.data.records);
                    commit("SET_LOADING_RECORDS", false);
                }).catch(e => {
                    console.log(e);
                    commit("SET_LOADING_RECORDS", false);
                })
        },
        loadRecordsByMinDuration({ commit }, duration) {
            commit("SET_LOADING_RECORDS", true);

            axios.get(`records/min-duration/${duration}`)
                .then(res => {
                    commit("SET_RECORDS", res.data.records);
                    commit("SET_LOADING_RECORDS", false);
                }).catch(e => {
                    console.log(e);
                    commit("SET_LOADING_RECORDS", false);
                })
        },
        SOCKET_CREATE_RECORD_IN_TABLE({ commit }, record) {
            commit("REALTIME_RECORD_ADD_TAB", record);
        }
    }
}